<div *ngIf="cashAward || inKindAward"
  class="full-page detail-page">
  <!-- Header -->
  <div class="page-header">
    <yc-i18n
      key="common:hdrAwardAndPaymentDetail"
      defaultValue="Award and Payment Detail">
    </yc-i18n>
  </div>

  <!-- Cash Award -->
  <div *ngIf="cashAward"
    [class.mb-3]="!!inKindAward">
    <ng-template *ngTemplateOutlet="awardDetails; context: {
      award: cashAward,
      isCash: true
    }"></ng-template>
  </div>

  <!-- In Kind Award -->
  <div *ngIf="inKindAward">
    <ng-template *ngTemplateOutlet="awardDetails; context: {
      award: inKindAward,
      isCash: false
    }"></ng-template>
  </div>

  

</div>

<ng-template #totalAmount
  let-inKindItems="inKindItems"
  let-currencyRequestedAmountEquivalent="currencyRequestedAmountEquivalent"
  let-currencyRequested="currencyRequested"
  let-isCash="isCash">
  <strong *ngIf="isCash">
    {{ currencyRequestedAmountEquivalent | gcMoney: currencyRequested }}
  </strong>
  <strong *ngIf="!isCash">
    <yc-i18n
      key="GLOBAL:textNumberUnits"
      [context]="{
        number: (inKindItems | gcInKindNumberOfUnits) | number
      }"
      defaultValue="__number__ units">
    </yc-i18n>
    <!-- Only show In Kind $ amounts in GM portal -->
    <ng-container *ngIf="!isForApplicantPortal">
      ({{ currencyRequestedAmountEquivalent | gcMoney: currencyRequested }})
    </ng-container>
  </strong>
</ng-template>

<ng-template #awardDetails
  let-isCash="isCash"
  let-award="award">
  <div class="award-header">
    <yc-i18n
      [key]="isCash ? 'common:hdrCashAward' : 'common:hdrInKindAward'"
      [defaultValue]="isCash ? 'Cash Award' : 'In-kind Award'">
    </yc-i18n>
  </div>
  <div class="award-section">
    <div class="left">
      <!-- Total Amount -->
      <div class="left-award-section">
        <yc-i18n
          key="GLOBAL:textTotalAmount"
          defaultValue="Total amount">
        </yc-i18n>
        <ng-template *ngTemplateOutlet="totalAmount; context: {
          inKindItems: award.inKindItems,
          currencyRequestedAmountEquivalent: award.currencyRequestedAmountEquivalent,
          currencyRequested: award.currencyRequested,
          isCash: isCash
        }"></ng-template>
      </div>
      <!-- Number of Payments -->
      <div class="left-award-section">
        <yc-i18n
          key="common:hdrPayments"
          defaultValue="Payments">
        </yc-i18n>
        <strong>
          {{ award.payments.length }}
        </strong>
      </div>

      <div *ngIf="!isCash">
        <yc-i18n
          key="common:textAwardBreakdown"
          defaultValue="Award breakdown">
        </yc-i18n>
        <strong *ngFor="let item of award.inKindItems"
          class="d-block">
          <ng-template *ngTemplateOutlet="inKindItemDisplay; context: {
            item: item
          }"></ng-template>
        </strong>
      </div>
    </div>

    <div class="right">
      <table class="table yc-table">
        <thead>
          <!-- Payment Header -->
          <th>
            <yc-i18n
              key="common:lblPayment"
              defaultValue="Payment">
            </yc-i18n>
          </th>
          <!-- Payment ID Header -->
          <th>
            <yc-i18n
              key="MANAGE:hdrPaymentId"
              defaultValue="Payment ID">
            </yc-i18n>
          </th>
          <!-- Payment Number Header -->
          <th>
            <yc-i18n
              key="MANAGE:textPaymentNumber"
              defaultValue="Payment number">
            </yc-i18n>
          </th>
          <!-- Status Header -->
          <th>
            <yc-i18n
              key="common:hdrStatus"
              defaultValue="Status">
            </yc-i18n>
          </th>
        </thead>
        <tbody>
          <tr *ngFor="let payment of award.payments">
            <!-- Payment Column -->
            <td>
              <ng-template *ngTemplateOutlet="totalAmount; context: {
                inKindItems: payment.inKindItems,
                currencyRequestedAmountEquivalent: payment.currencyRequestedAmountEquivalent,
                currencyRequested: payment.currencyRequested,
                isCash: isCash
              }"></ng-template>
              <div class="mb-3">
                <gc-payment-dates-block
                  [fundingSourceType]="payment.typeId"
                  [scheduledDate]="payment.scheduledDate"
                  [issuedDate]="payment.issuedDate"
                  [clearedDate]="payment.clearedDate"
                  [isForApplicantPortal]="isForApplicantPortal">
                </gc-payment-dates-block>
              </div>
              <div *ngFor="let item of payment.inKindItems">
                <ng-template *ngTemplateOutlet="inKindItemDisplay; context: {
                  item: item
                }"></ng-template>
              </div>
            </td>
            <!-- Payment ID Column -->
            <td>
              {{ payment.id }}
            </td>
            <!-- Payment Number Column -->
            <td>
              <!-- Payment Number -->
              <div *ngIf="payment.paymentNumber">
                <yc-i18n
                  key="MANAGE:textPaymentNumber"
                  defaultValue="Payment number">
                </yc-i18n>: 
                {{ payment.paymentNumber }}
              </div>

              <!-- Payment Type -->
              <gc-payment-type-display
                [paymentType]="payment.paymentType"
                [paymentStatus]="payment.statusId"
                [isInKind]="payment.isUnits"
                [showPaymentTypePrefix]="true"
                [processorType]="payment.processor">
              </gc-payment-type-display>
            </td>
            <!-- Status Column -->
            <td>
              <gc-payment-status-block
                [status]="payment.status"
                [subStatus]="payment.substatus"
                [statusId]="payment.statusId"
                [isArchived]="isArchived"
                [hidePaymentStatus]="isForApplicantPortal && payment.hidePaymentStatus"
                [alternatePaymentStatusText]="payment.alternatePaymentStatusText"
                [statusDate]="payment.statusDate"
                [isForApplicantPortal]="isForApplicantPortal"
                [processor]="payment.processor"
                [payeeOverride]="payment.payeeOverride">
              </gc-payment-status-block>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #inKindItemDisplay
  let-item="item">
  {{ item.count }}
  {{ allItemsMap[item.itemIdentification]?.name || item.itemIdentification }}
  <ng-container *ngIf="!isForApplicantPortal">
    ({{ ((allItemsMap[item.itemIdentification].value) * item.count) | gcMoney }})
  </ng-container>
</ng-template>